/// <amd-module name="Wiki/Mermaid/Helpers" />
import * as Mermaid from "mermaid";
import { IVssPageContext } from "VSS/Platform/Context";
import { isFeatureFlagEnabled } from "VSS/Platform/Feature";
import { IVssThemeService } from "VSS/Platform/Theming";
import { MermaidTheme } from "Wiki/Mermaid/Constants";

const darkThemeCSS = `
.titleText { 
    fill: rgba(var(--palette-neutral-100), .95);
}

.taskTextOutside0, .taskTextOutside1, .taskTextOutside2, .taskTextOutside3 {
    fill: lightgrey !important; 
}
`;

const highContrastCSS = `
.node rect, .node circle, .node ellipse, .node polygon, .cluster rect {
  fill: Background;
}
.edgePath .path, .arrowheadPath  {
    stroke: ButtonText;
}

#arrowhead, .messageText, #sequencenumber, .loopText {
    fill: ButtonText;
}
.messageLine0, messageLine1, .actor-line {
    stroke: ButtonText;
}
#crosshead path {
    fill: ButtonText !important;
    stroke: ButtonText !important;
}

.titleText {
    fill: ButtonText;
}
.taskTextOutside0, .taskTextOutside1, .taskTextOutside2, .taskTextOutside3 {
    fill: ButtonText !important; 
}
.sectionTitle0, .sectionTitle1, .sectionTitle2, .sectionTitle3 {
   fill: ButtonText;
}
`;
const oldDiagrams = ["sequenceDiagram", "gantt", "graph", "subgraph", "flowchart", "classDiagram", "stateDiagram", "journey", "pie", "requirementDiagram", "gitGraph"];
const newDiagrams = [...oldDiagrams, "erDiagram", "C4Context"];

const oldDiagramsRegex = new RegExp(oldDiagrams.map((o) => `^\\s*${o}`).join("|"));
const newDiagramsRegex = new RegExp(newDiagrams.map((o) => `^\\s*${o}`).join("|"));

export function mermaidInitialize(theme: MermaidTheme): void {
    const isHighContrastMode = _isHighContrastMode();
    const themeCSS = isHighContrastMode ? highContrastCSS : theme === MermaidTheme.Dark ? darkThemeCSS : undefined;
    Mermaid.initialize({ startOnLoad: false, theme, themeCSS });
}

export function mermaidRender(id: string, txt: string, renderCallback: (svgCode: string) => void, container?: HTMLElement): string {
    return Mermaid.render(id, txt, renderCallback, container);
}


export function isSupportedDiagram(content: string, isNewDiagramSupported?: boolean): boolean {
    //Below "If" condition is used to support new diagrams as per mermaid8.12.0
    // Diagram names are case-sensitive
    if (isNewDiagramSupported) {
        //Mermaid library always add new type of diagram and some of them are in experimental state.
        //and we can't add those diagram which are not fully supported that's why we are checking using "match" condition.
        if (content.match(newDiagramsRegex)) {
            return true;
        }
        return false;
    } else {
        //if feature flag is disable then we are considering only those diagram which is supported
        //in mermaid 8.2.6
        if (content.match(oldDiagramsRegex)) {
            return true;
        }
        return false;
    }
}
export function getMermaidTheme(themeService: IVssThemeService): MermaidTheme {
    return themeService.getCurrentTheme().isDark ? MermaidTheme.Dark : MermaidTheme.Default;
}

export function isIE(): boolean {
    const userAgent = window.navigator.userAgent.toLowerCase();
    const msie = /msie ([\d+.]+)/i.exec(navigator.userAgent);

    return !!msie || userAgent.indexOf("trident") !== -1;
}

export function contentOverflowsContainer(container: HTMLElement): boolean {
    return container.offsetWidth < container.scrollWidth || container.offsetHeight < container.scrollHeight;
}

export function isNewMermaidDiagramSupported(pageContext: IVssPageContext): boolean {
    return isFeatureFlagEnabled(pageContext, "Wiki.Web.EnableNewMermaidSupportedDiagram");
}

export function isMermaidRenderExtraFunctionEnabled(pageContext: IVssPageContext): boolean {
    return isFeatureFlagEnabled(pageContext, "Wiki.Web.MermaidRenderExtraFunction");
}

function _isHighContrastMode(): boolean {
    let isAutoHighContrast = false;
    const probe = document.createElement("span");
    probe.style.color = "#123456";
    document.body.appendChild(probe);
    const style = getComputedStyle(probe);

    if (style && style.color && style.color.replace(/ /g, "") !== "rgb(18,52,86)" && /^rgb\(\d+,\s?\d+,\s?\d+\)$/.test(style.color)) {
        isAutoHighContrast = true;
    }

    if (probe.parentNode) {
        probe.parentNode.removeChild(probe);
    }
    return isAutoHighContrast;
}
